module.exports = __webpack_public_path__ + "static/media/start_Icon.a31403a9.svg";